import { Autocomplete, TextField, Box, Tooltip, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useAuth } from '@clerk/clerk-react';
import { jxScrollbarThin } from '../../JxControls/jxScrollbarStyle';

const J = {
    text: '#e0f0ff',
    muted: '#a3d1ff',
    accent: '#66b2ff',
    accent2: '#677583',
    surface: '#0d1f33',
    border: '0.5px solid #294766',
};

// Autocomplete dropdown — typ topic naam, selecteer, entries laden
export default function TopicSearch({ journals, selectedName, onSelect }) {
    //
    const { getToken, sessionClaims } = useAuth();
    const isAdmin = sessionClaims?.role === 'admin';

    const selected = journals.find((j) => j.name === selectedName) ?? null;

    // ADDED — copy fresh Clerk JWT to clipboard for API testing
    const handleCopyToken = async () => {
        const token = await getToken();
        await navigator.clipboard.writeText(token);
    };

    return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Autocomplete
                options={journals}
                getOptionLabel={(j) => (j.name === '__recent__' ? 'Recent' : j.name)}
                value={selected}
                isOptionEqualToValue={(option, value) => option.name === value.name}
                onChange={(_, val) => onSelect(val?.name ?? null)}
                sx={{ width: '100%' }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder="Search topic..."
                        variant="outlined"
                        size="small"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                color: J.text,
                                bgcolor: J.surface,
                                fontSize: 13,
                                '& fieldset': { border: J.border },
                                '&:hover fieldset': { borderColor: J.accent },
                                '&.Mui-focused fieldset': { borderColor: J.accent2 },
                            },
                            '& .MuiSvgIcon-root': { color: J.muted },
                        }}
                    />
                )}
                renderOption={(props, option) => {
                    const { key, ...rest } = props;
                    return (
                        <Box
                            key={key}
                            component="li"
                            {...rest}
                            sx={{
                                fontSize: 13,
                                color: J.text,
                                bgcolor: J.surface,
                                '&:hover': { bgcolor: '#1a3a55' },
                                '&.Mui-focused': { bgcolor: '#1a3a55' },
                            }}
                        >
                            <Box component="span" sx={{ flex: 1, color: option.total === null ? J.accent : J.text }}>
                                {option.name === '__recent__' ? 'Recent' : option.name}
                            </Box>
                            <Box component="span" sx={{ color: J.muted, fontSize: 11 }}>
                                {option.total ?? ''} {/* CHANGED */}
                            </Box>
                        </Box>
                    );
                }}
                slotProps={{
                    paper: {
                        className: jxScrollbarThin,
                        sx: {
                            bgcolor: J.surface,
                            border: J.border,
                            borderRadius: 1,
                            '& .MuiAutocomplete-option:hover': { bgcolor: '#1a3a55 !important' },
                            '& .MuiAutocomplete-option.Mui-focused': { bgcolor: '#1a3a55 !important' },
                        },
                    },
                }}
            />
            {isAdmin && (
                <Tooltip title="Copy JWT">
                    <IconButton onClick={handleCopyToken} size="small" sx={{ color: J.muted }}>
                        <ContentCopyIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
}
